































































































































import {
  tDeviceTransactionInfo,
  tPayTransactionInfo,
  TransactionParams,
  tTransactionModal
} from '@/store/interfaces/transactions';
import Device from '../Transfer/Detail/Device.vue';
import Transaction from '@/components/TransactionTickets/Reusable/Transaction.vue';
import Pay from '@/components/TransactionTickets/Transfer/Detail/Pay.vue';
import { dateTime } from '@/util/filters';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'DetailModal',
  components: {
    Device,
    Transaction,
    Pay,
  },
  props: {
    viewDetails: {
      type: Boolean,
      required: true,
    },
    transaction: {
      type: Object as PropType<TransactionParams>,
      required: true,
    },
  },
  data: () => ({
    dateTime,
  }),
  methods: {
    refund(): void {
      this.$emit('newRefund', true);
    },
    isTransactionRecord(): boolean {
      return this.$route.name === 'transactionsTicketsRecord';
    },
  },
  computed: {
    syncedViewDetails: {
      get(): boolean {
        return this.viewDetails;
      },
      set(value: boolean): void {
        this.$emit('update:viewDetails', value);
      },
    },
    url(): string {
      const lat = this.transaction.latitude;
      const lon = this.transaction.longitude;
      return `https://www.google.com/maps?q=${lat},${lon}&hl=es&z=14&output=embed`;
    },
    canDoRefund(): boolean {
      return (
        this.transaction.distribution === 'credit_card' &&
        this.isTransactionRecord() &&
        this.transaction.status === 'success'
      );
    },
    isPayLink(): boolean {
      return this.transaction.order_kind === 'payment_link';
    },
    canGoToTheProfile(): boolean {
      return !this.transaction.user_id;
    },
    device(): tDeviceTransactionInfo {
      return {
        device_name: this.transaction.device_name,
        device_platform: this.transaction.device_platform,
        device_vendor: this.transaction.device_vendor,
        device_version: this.transaction.device_version,
      };
    },
    getTransaction(): tTransactionModal {
      return {
        authorization_number: this.transaction.authorization_number,
        reference_number: this.transaction.reference_number,
        risk: this.transaction.risk,
        status: this.transaction.status,
        response_code: this.transaction.response_code,
        biometrics: this.transaction.biometrics,
        distribution: this.transaction.distribution,
        card_last_digits: this.transaction.card_last_digits,
        card_network: this.transaction.card_network,
      };
    },
    pay(): tPayTransactionInfo {
      return {
        card_last_digits: this.transaction.card_last_digits,
        card_network: this.transaction.card_network,
        balance_amount_cents: this.transaction.balance_amount_cents,
        card_amount_cents: this.transaction.card_amount_cents,
        distribution: this.transaction.distribution,
        balance_amount_formatted: this.transaction.balance_amount_formatted,
        card_amount_formatted: this.transaction.card_amount_formatted,
        total_formatted: this.transaction.total_formatted,
      };
    },
  },
});
